import { useMemo } from 'react'

import { AgChartOptions, AgLineSeriesOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export interface Rebased100ChartProps extends ICReportChartPrimitive {}

export const Rebased100Chart: React.FC<Rebased100ChartProps> = ({ params, options }) => {
  const query = diversifiers.useRebased100Monthly(params)
  const data = query.data ?? []

  const formattedData = useMemo(() => {
    return data.map((item: any) => ({
      ...item,
      date: new Date(item.date),
    }))
  }, [data])

  const mergedOptions: AgChartOptions = {
    data: formattedData,
    height: 400,
    series: [
      ...Object.keys(formattedData?.[0] ?? {})
        .filter((key) => !['date', params.fund_name].includes(key))
        .map(
          (key) =>
            ({
              type: 'line',
              xKey: 'date',
              yKey: key,
              marker: {
                size: 0,
              },
            }) satisfies AgLineSeriesOptions,
        ),
      {
        type: 'line',
        xKey: 'date',
        yKey: params.fund_name!,
        stroke: 'black',
        marker: {
          size: 0,
          fill: 'black',
        },
      },
    ],
    axes: [
      {
        type: 'time',
        position: 'bottom',
        nice: false,
        label: {
          format: '%d %b %Y',
        },
      },
      { type: 'number', position: 'left' },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
